import { render, staticRenderFns } from "./UserGrouping.vue?vue&type=template&id=43ff6d13&"
import script from "./UserGrouping.vue?vue&type=script&lang=ts&"
export * from "./UserGrouping.vue?vue&type=script&lang=ts&"
import style0 from "./UserGrouping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports